/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box } from '@mui/material';
import './ExpiredInsuranceViewModal.css';
import CustomModal from './../../CustomModal/CustomModal';
import ModalFooter from './../../CustomModal/ModalFooter';
import ModalHeader from './../../CustomModal/ModalHeader';

import { themes } from '../../../themes/themes';
import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import CardContentTile from '../../../components/CardContentTile/CardContentTile';
import { getAmount } from '../../../configs/utils';
import { baseDateFormatting } from '../../../helper';
import { DateField } from '../../../../components';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  expiredInsuranceViewData: any;
  trans?: any;
}

const ExpiredInsuranceViewModalPresenter = ({
  isModalOpen,
  closeModal,
  expiredInsuranceViewData,
  trans,
}: ModalProps) => {
  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="687px"
      modalWidth="450px"
    >
      <ModalHeader
        modal={{ modal_title: trans('View Insurance') }}
        closeModal={closeModal}
      />
      <Grid container spacing={3} style={{ marginTop: '5px' }}>
        <Grid item xs={12}>
          <CardContentTile
            tile_key={trans('Insure')}
            tile_value={
              expiredInsuranceViewData?.insurers?.name
                ? expiredInsuranceViewData?.insurers?.name
                : '--'
            }
            is_bold={true}
            value_color={themes.blackDefault}
          />
          <CardContentTile
            tile_key={trans('Policy Type')}
            tile_value={expiredInsuranceViewData?.policytype?.name}
            is_bold={true}
            value_color={themes.blackDefault}
          />
          <CardContentTile
            tile_key={trans('Policy Number')}
            tile_value={
              expiredInsuranceViewData?.policy_number != 'undefined'
                ? expiredInsuranceViewData?.policy_number
                : '--'
            }
          />
          <CardContentTile
            tile_key={trans('Start Date')}
            tile_value={
              <DateField
                value={expiredInsuranceViewData?.start_date}
                format={baseDateFormatting}
              />
            }
          />
          <CardContentTile
            tile_key={trans('End Date')}
            tile_value={
              <DateField
                value={expiredInsuranceViewData?.expiry_date}
                format={baseDateFormatting}
              />
            }
          />
          <CardContentTile
            tile_key={trans('Category')}
            tile_value={
              expiredInsuranceViewData?.category != 'undefined'
                ? expiredInsuranceViewData?.category
                : '--'
            }
          />
          <CardContentTile
            tile_key={trans('Amount')}
            tile_value={
              expiredInsuranceViewData?.amount != 'undefined' ||
              expiredInsuranceViewData?.amount
                ? getAmount(expiredInsuranceViewData?.amount)
                : '0'
            }
            is_bold={true}
            value_color={themes.blackDefault}
          />
        </Grid>

        {expiredInsuranceViewData?.emp_insurance_documents[0]?.document && (
          <Grid item xs={5}>
            <DropAndSelect
              src={
                expiredInsuranceViewData?.emp_insurance_documents[0]?.document
              }
              isAttachmentSigned={true}
              disabledDeleteBtn={true}
            />
          </Grid>
        )}
      </Grid>

      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickCancel={() => {
          closeModal();
        }}
        isSubmitButton={false}
        isCancelButton={false}
        isCloseButton={true}
      />
    </CustomModal>
  );
};

export default ExpiredInsuranceViewModalPresenter;
